import { Fragment, useState } from "react";
import { Checkbox } from "@/components/ui/shadcn/checkbox";
import {
  Command,
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/shadcn/command";

export default function ModelSelectorDialog({
  open,
  onOpenChange,
  models,
  selectedModel,
  onSelectModel,
  hasCategoryFilter,
}) {
  const [modelTypes, setModelTypes] = useState({
    t2i: { value: true, label: "Text 2 Image" },
    i2v: { value: true, label: "Image 2 Video" },
    v2v: { value: true, label: "Video 2 Video" },
    t2s: { value: true, label: "Text 2 Speech" },
    utils: { value: true, label: "Utils" },
  });

  return (
    <CommandDialog className="h-3/4" open={open} onOpenChange={onOpenChange}>
      <Command
        className="ModelSelector bg-card"
        value={selectedModel?.endpoint}
        filter={(_value, search, keywords) => {
          const haystack = (keywords || []).join(" ").toLowerCase();
          return haystack.includes(search.trim().toLowerCase()) ? 1 : 0;
        }}>
        <CommandInput
          className="ModelSelector__search"
          placeholder="Search for a model..."
        />
        {!hasCategoryFilter && (
          <div className="flex items-center gap-3 p-4 border-b">
            {Object.keys(modelTypes).map((key) => (
              <div className="flex items-center gap-2" key={key}>
                <Checkbox
                  id={`ModelSelector__filter-${key}`}
                  name={`filter-${key}`}
                  checked={modelTypes[key]?.value}
                  onCheckedChange={(checked) =>
                    setModelTypes((prev) => ({
                      ...prev,
                      [key]: { ...prev[key], value: checked },
                    }))
                  }
                />
                <label
                  className="text-[10px] text-secondary-foreground/80 hover:text-secondary-foreground capitalize select-none capitalize  cursor-pointer"
                  onClick={() =>
                    setModelTypes((prev) =>
                      Object.fromEntries(
                        Object.entries(prev).map(([k, v]) => [
                          k,
                          { ...v, value: k === key },
                        ]),
                      ),
                    )
                  }>
                  {modelTypes[key]?.label}
                </label>
              </div>
            ))}
          </div>
        )}
        <CommandList className="max-h-full">
          <CommandEmpty className="text-xs text-secondary-foreground/80 p-5 text-center">
            No models found.
          </CommandEmpty>
          {Object.entries(
            models
              .filter((model) => modelTypes[model.category]?.value)
              .reduce((groups, model) => {
                const group = model.group || "Other";
                if (!groups[group]) groups[group] = [];
                groups[group].push(model);
                return groups;
              }, {}),
          )
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([groupName, groupModels]) => (
              <Fragment key={groupName}>
                <CommandGroup heading={groupName}>
                  {groupModels
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((model) => (
                      <CommandItem
                        value={model.endpoint}
                        keywords={[model.name, model.group].filter(Boolean)}
                        key={model._id}
                        className="ModelSelector__model px-4 py-2 flex flex-col gap-1 items-start"
                        onSelect={() => {
                          onSelectModel(model);
                          onOpenChange(false);
                        }}>
                        <div className="flex items-center justify-between w-full">
                          <span>{model.name}</span>
                          <span className="text-[10px]">
                            {modelTypes[model.category]?.label}
                          </span>
                        </div>
                        <span className="text-[10px] opacity-60">
                          {model.description}
                        </span>
                      </CommandItem>
                    ))}
                </CommandGroup>
                <CommandSeparator />
              </Fragment>
            ))}
        </CommandList>
      </Command>
    </CommandDialog>
  );
}
